/* Balance Mobile shared pieces: plans pop-up / sheet, ⓘ pop-overs and the
   dots under swipeable plan cards. Safe to load more than once. */
(function () {
  if (window.__bmComponents) return;
  window.__bmComponents = true;

  // ---------- plans pop-up ----------
  document.addEventListener('click', function (event) {
    var opener = event.target.closest('[data-bm-dialog-open]');
    if (opener) {
      var dialog = document.getElementById(opener.getAttribute('data-bm-dialog-open'));
      if (dialog && typeof dialog.showModal === 'function') {
        event.preventDefault();
        dialog.showModal();
        document.documentElement.classList.add('bm-dialog-open');
        // optional jump to a part of the dialog (e.g. "See plans" → plans)
        var targetId = opener.getAttribute('data-bm-dialog-scroll');
        var target = targetId && document.getElementById(targetId);
        if (target) {
          target.scrollIntoView({ block: 'start' });
          target.focus({ preventScroll: true });
        } else {
          dialog.scrollTop = 0;
        }
      }
      return;
    }

    var closer = event.target.closest('[data-bm-dialog-close]');
    if (closer) {
      var open = closer.closest('dialog');
      if (open) open.close();
      return;
    }

    // a click on the backdrop lands on the <dialog> itself
    if (event.target.matches && event.target.matches('dialog.bm-dialog')) {
      event.target.close();
    }
  });

  document.addEventListener(
    'close',
    function (event) {
      if (event.target.matches && event.target.matches('dialog.bm-dialog')) {
        document.documentElement.classList.remove('bm-dialog-open');
      }
    },
    true
  );

  // ---------- ⓘ pop-overs ----------
  function closeAllInfo(except) {
    document.querySelectorAll('[data-bm-info] .bm-info__button[aria-expanded="true"]').forEach(function (button) {
      if (button === except) return;
      button.setAttribute('aria-expanded', 'false');
      var pop = document.getElementById(button.getAttribute('aria-controls'));
      if (pop) pop.hidden = true;
    });
  }

  document.addEventListener('click', function (event) {
    var button = event.target.closest('[data-bm-info] .bm-info__button');
    if (!button) {
      if (!event.target.closest('.bm-info__pop')) closeAllInfo(null);
      return;
    }
    event.preventDefault();
    var pop = document.getElementById(button.getAttribute('aria-controls'));
    var opening = button.getAttribute('aria-expanded') !== 'true';
    closeAllInfo(button);
    button.setAttribute('aria-expanded', opening ? 'true' : 'false');
    if (pop) pop.hidden = !opening;
  });

  document.addEventListener('keydown', function (event) {
    if (event.key === 'Escape') closeAllInfo(null);
  });

  // ---------- Mobile plan choice on the product page ----------
  // companionFor(scope): undefined when the page has no Mobile plan step (the
  // caller keeps its old behaviour), null for "Phone only", else the variant
  // id of the SIM to add with the phone.
  window.BalanceMobile = window.BalanceMobile || {};
  window.BalanceMobile.companionFor = function (scope) {
    var root = (scope && scope.querySelector && scope.querySelector('[data-bm-plan-choice]')) ||
      document.querySelector('[data-bm-plan-choice]');
    if (!root) return undefined;
    var chosen = root.querySelector('.bm-tile__input:checked');
    if (!chosen || chosen.value !== 'with') return null;
    if (chosen.dataset.bmSimVariant) return chosen.dataset.bmSimVariant;
    var sim = root.querySelector('.bm-subchoice__input:checked');
    return sim ? sim.value : null;
  };

  // addonsFor(scope): [{ id, quantity }] for the ticked add-ons (a product with
  // colours gives the chosen colour's variant).
  window.BalanceMobile.addonsFor = function (scope) {
    var root = (scope && scope.querySelector && scope.querySelector('[data-bm-addons]')) ||
      document.querySelector('[data-bm-addons]');
    if (!root) return [];
    var ids = [];
    root.querySelectorAll('.bm-tile__input[data-bm-addon]:checked').forEach(function (input) {
      var tile = input.closest('.bm-tile');
      var qtyInput = tile.querySelector('.bm-qty__input');
      var quantity = Math.max(1, Math.min(10, parseInt(qtyInput && qtyInput.value, 10) || 1));
      var id = input.dataset.bmAddonVariant;
      if (!id) {
        var chip = tile.querySelector('.bm-chips__input:checked');
        id = chip && chip.value;
      }
      if (id) ids.push({ id: id, quantity: quantity });
    });
    return ids;
  };

  // protectFor(scope): { id, quantity, selling_plan } when Balance Protect is
  // ticked (with the chosen subscription plan), else null.
  window.BalanceMobile.protectFor = function (scope) {
    var root = (scope && scope.querySelector && scope.querySelector('[data-bm-protect-step]')) ||
      document.querySelector('[data-bm-protect-step]');
    if (!root) return null;
    var box = root.querySelector('.bm-tile__input[data-bm-protect]:checked');
    if (!box) return null;
    var plan = root.querySelector('.bm-subchoice__input:checked');
    return {
      id: box.dataset.bmProtectVariant,
      quantity: 1,
      selling_plan: plan ? parseInt(plan.value, 10) : undefined
    };
  };

  // add-on quantity: − / + buttons, kept between 1 and 10
  document.addEventListener('click', function (event) {
    var button = event.target.closest && event.target.closest('[data-bm-qty-step]');
    if (!button) return;
    var input = button.closest('[data-bm-qty]').querySelector('.bm-qty__input');
    var next = (parseInt(input.value, 10) || 1) + parseInt(button.getAttribute('data-bm-qty-step'), 10);
    input.value = Math.max(parseInt(input.min, 10) || 1, Math.min(parseInt(input.max, 10) || 10, next));
  });

  // colour chips: show the chosen colour's name next to the label and its
  // variant image in the tile's thumbnail
  document.addEventListener('change', function (event) {
    var chip = event.target.closest && event.target.closest('.bm-chips__input');
    if (!chip) return;
    var value = chip.closest('[data-bm-chips]').querySelector('[data-bm-chips-value]');
    if (value) value.textContent = chip.dataset.bmChipTitle || '';
    var image = chip.dataset.bmChipImage && chip.closest('.bm-tile').querySelector('.bm-tile__image img');
    if (image) {
      image.removeAttribute('srcset');
      image.src = chip.dataset.bmChipImage;
    }
  });

  // ---------- nested content inside option tiles ----------
  function syncNested(scope) {
    (scope || document).querySelectorAll('.bm-tile [data-bm-nested]').forEach(function (nested) {
      var tile = nested.closest('.bm-tile');
      var input = tile && tile.querySelector('.bm-tile__input');
      var open = !!(input && input.checked);
      nested.inert = !open;
      nested.querySelectorAll('input, select, textarea').forEach(function (field) {
        field.disabled = !open || field.hasAttribute('data-bm-unavailable');
      });
    });
  }

  document.addEventListener('change', function (event) {
    if (event.target.matches && event.target.matches('.bm-tile__input')) syncNested(document);
  });

  // ---------- dots under swipeable plan cards ----------
  function bindCarousel(root) {
    if (root.__bmBound) return;
    root.__bmBound = true;
    var track = root.querySelector('[data-bm-carousel-track]');
    var dots = root.querySelectorAll('.bm-plan-cards__dot');
    if (!track || !dots.length) return;
    var update = function () {
      var cards = track.children;
      var left = track.getBoundingClientRect().left;
      var best = 0;
      var bestDistance = Infinity;
      for (var i = 0; i < cards.length; i++) {
        var distance = Math.abs(cards[i].getBoundingClientRect().left - left);
        if (distance < bestDistance) {
          bestDistance = distance;
          best = i;
        }
      }
      dots.forEach(function (dot, i) {
        dot.classList.toggle('is-active', i === best);
      });
    };
    track.addEventListener('scroll', function () {
      window.requestAnimationFrame(update);
    }, { passive: true });
  }

  function bindAll() {
    document.querySelectorAll('[data-bm-carousel]').forEach(bindCarousel);
    syncNested(document);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', bindAll);
  } else {
    bindAll();
  }
  document.addEventListener('shopify:section:load', bindAll);
})();
